import Icons from 'components/Icons'
import Heading from "components/Typography/Header";
import Paragraph from "components/Typography/Paragraph";
import Button from "components/Button";
import { Monitor, Zap, Lock, Headphones, Star } from 'lucide-react';
import { Link } from "react-router-dom";

const Financial = () => {
    return (
        <section className='py-24 md:py-40 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-secondary/5 via-transparent to-primary/5'></div>
            
            <div className='max-w-7xl mx-auto px-6 relative z-10'>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-16 items-center'>
                    <div className='space-y-10'>
                        <div className='inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-secondary/10 to-primary/10 rounded-full border border-secondary/20'>
                            <Icons className="bg-gradient-to-r from-secondary to-primary p-2 rounded-lg"> 
                                <Star size={24} className="text-white" /> 
                            </Icons>
                            <span className="text-secondary font-semibold text-sm">Neden SkyPay'ı Seçmelisiniz?</span>
                        </div>

                        <div className='space-y-6'>
                            <Heading level={1} className="text-white text-5xl lg:text-6xl font-bold leading-tight bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                                Dijital Ödeme<br />
                                <span className="bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">Lideriyiz</span>
                            </Heading>
                            <Paragraph className="text-gray-300 text-xl leading-relaxed max-w-2xl">
                                SkyPay, kullanıcı memnuniyetini önceleyen profesyonel altyapısı, 7/24 canlı destek ve yüksek güvenlik standartları ile dijital ödeme sektöründe lider konumdadır.
                            </Paragraph>
                        </div>

                        <Link to="/register">
                            <Button className="bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90 text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:shadow-primary/25 transition-all duration-300 hover:scale-105">
                                Hemen Üye Ol
                            </Button>
                        </Link>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300 hover:transform hover:scale-105'>
                            <div className='w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-xl flex items-center justify-center mb-6 group-hover:shadow-lg group-hover:shadow-primary/25 transition-all duration-300'>
                                <Monitor size={32} className="text-white" />
                            </div>
                            <div className='space-y-3'>
                                <Heading level={4} className="text-white text-xl font-bold group-hover:text-primary transition-colors duration-300">Mobil Uyumlu Platform</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">Mobil ve masaüstü uyumlu arayüz ile her yerden erişim</Paragraph>
                            </div>
                        </div>

                        <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105'>
                            <div className='w-16 h-16 bg-gradient-to-r from-secondary to-primary rounded-xl flex items-center justify-center mb-6 group-hover:shadow-lg group-hover:shadow-secondary/25 transition-all duration-300'>
                                <Zap size={32} className="text-white" />
                            </div>
                            <div className='space-y-3'>
                                <Heading level={4} className="text-white text-xl font-bold group-hover:text-secondary transition-colors duration-300">Yüksek Performans</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">Kesintisiz sunucu altyapısı ile hızlı işlem garantisi</Paragraph>
                            </div>
                        </div>

                        <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300 hover:transform hover:scale-105'>
                            <div className='w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-xl flex items-center justify-center mb-6 group-hover:shadow-lg group-hover:shadow-primary/25 transition-all duration-300'>
                                <Lock size={32} className="text-white" />
                            </div>
                            <div className='space-y-3'>
                                <Heading level={4} className="text-white text-xl font-bold group-hover:text-primary transition-colors duration-300">SSL Sertifikalı Güvenlik</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">256-bit SSL şifreleme teknolojisi ile tam güvenlik</Paragraph>
                            </div>
                        </div>

                        <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105'>
                            <div className='w-16 h-16 bg-gradient-to-r from-secondary to-primary rounded-xl flex items-center justify-center mb-6 group-hover:shadow-lg group-hover:shadow-secondary/25 transition-all duration-300'>
                                <Headphones size={32} className="text-white" />
                            </div>
                            <div className='space-y-3'>
                                <Heading level={4} className="text-white text-xl font-bold group-hover:text-secondary transition-colors duration-300">E-posta Müşteri Desteği</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">E-posta ile profesyonel müşteri destek hizmeti</Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Financial;